import React from "react";
import { T, useTranslateKey } from "../hooks/useTranslate";

import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ReactComponent as NoticeIcon } from '../assets/icons/notice-icon.svg';

const GlobalNoticeComponent = () => {
  const theme = useTheme();
  const viewportIsSmall = useMediaQuery(theme.breakpoints.up("sm"));
  const { showBanner } = useFlags();
  const translatedKey = useTranslateKey(showBanner?.bannerKey);
  const bannerMessage = translatedKey !== `{{${showBanner?.bannerKey}}}` ? translatedKey : showBanner?.bannerMessage;

  return showBanner?.show && (
    <Stack
      className="notice-stack"
      flexDirection="row"
      alignItems="center"
      gap={1}
      p={1.5}
      mr={!viewportIsSmall && 2}
      ml={!viewportIsSmall && 2}
      variant={showBanner?.severity}
    >
      <Stack>
        <NoticeIcon className="notice-icon" width={20} height={20} />
      </Stack>
      <Typography
        variant="body1"
        sx={{
          fontSize: "calc(12px * var(--unicity-font-scale, 1))",
          fontWeight: "400",
        }}
      >
        <strong><T>notice</T>:</strong> {bannerMessage}
      </Typography>
    </Stack>
  )
}

export { GlobalNoticeComponent }